import React from 'react';
import "../../../components/sandbox/index.css"
import {Arguments} from "../common/Arguments";

const baseUrl = Arguments.reactUrl.replace("/#", "") + "/att/documents/social/"
const ChangeOrganization = () => {
    return (
        <>
            <div className="panel panel-default mt-20">
                <p style={{fontWeight: 'bold', marginLeft: 20, fontSize: 20}}>社会团体换届</p>
            </div>
            <div className="panel panel-default mt-20">
                <div className="panel-header">（一）社会团体换届前的准备工作</div>
                <div className="panel-body">
                    <p>1．理事会应在任期届满6个月前组织换届筹备工作，在召开换届会议前，社会团体负责人与市社科联社会组织部就换届时间、新一届理事（监事）候选人、新一届党组织候选人、章程修改方案等换届相关事宜及新一届社会团体工作设想进行深入沟通。社会团体换届要在会员（代表）大会召开前1个月向市社科联报送社会团体新修改的章程草案、理事会候选人名单及大会工作报告等，经市社科联审查批复后方可召开换届大会。</p>
                    <p>2．换届中涉及到法定代表人离任（变更）的需要进行法定代表人离任审计。离任审计应选择有资质的专业审计机构出具《法定代表人任期经济责任审计报告》，审计期自法定代表人任期起至下一届换届大会召开之月。</p>
                    <p>3．换届工作由理事会或常务理事会（以下简称理事会）负责，理事会可成立由理事代表、监事代表、党组织代表和会员代表组成的换届选举委员会，负责换届选举工作。社会团体召开理事会或换届选举委员会研究换届相关事项，理事会须有2／3以上理事出席方能召开，其决议须经到会理事2／3以上表决通过方能生效。</p>
                    <p> 理事会或换届选举委员会的职责是：</p>
                    <p> （1）制定换届选举工作方案，定期召开会议研究讨论换届选举重大事项；</p>
                    <p> （2）组织提名会长或理事长、副会长或副理事长、秘书长、常务理事、理事以及监事长、监事建议候选人；</p>
                    <p> （3）组织推荐新一届党组织成员（原则上社会团体会长或理事长、法定代表人和党支部书记为同一人）；</p>
                    <p> （4）组织梳理会员名册，按章程审核会员资格条件；</p>
                    <p> （5）拟订社会团体章程修订稿（参照市民政局提供的章程范本）及换届选举相关材料。主要包括研究审议本届理事会工作报告（草案）、研究审议本届理事会财务报告（草案）、研究审议换届会议议程、研究其他特殊事项等。</p>
                    <p>4．向市社科联提出换届申请，需报送如下材料（社科联留存一份）：</p>
                    <p> （1）关于天津市××××理事会换届的请示；<a href={`${baseUrl}关于天津市××××理事会换届的请示.docx`}
                                                             style={{color: 'blue'}}>点此下载</a></p>
                    <p> （2）天津市社科联所属学会换届申请表；<a href={`${baseUrl}天津市社科联所属社团换届申请表.doc`}
                                                             style={{color: 'blue'}}>点此下载</a></p>
                    <p> （3）关于中共××××支部委员会换届的请示；<a
                        href={`${baseUrl}关于中共××××支部委员会换届的请示.docx`}
                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （4）章程草案；<a href={`${baseUrl}章程示范文本.doc`} style={{color: 'blue'}}>点此下载</a></p>
                    <p> （5）天津市××××第×届理事会候选人基本情况表；<a
                        href={`${baseUrl}天津市××××第×届理事会候选人基本情况表.docx`}
                        style={{color: 'blue'}}>点此下载</a>
                    </p>
                    <p> （6）天津市××××第×届监事会（监事）候选人基本情况表；<a
                        href={`${baseUrl}天津市××××第×届监事会（监事）候选人基本情况表.docx`}
                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （7）个人会员名册；<a href={`${baseUrl}个人会员名册.xlsx`} style={{color: 'blue'}}>点此下载</a>
                    </p>
                    <p> （8）团体会员名册；<a href={`${baseUrl}团体会员名册.doc`} style={{color: 'blue'}}>点此下载</a>
                    </p>
                    <p> （9）中共天津市××××第×届支部委员会拟任委员情况表；<a
                        href={`${baseUrl}中共天津市××××第×届支部委员会拟任委员情况表.docx`}
                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （10）本届理事会工作报告（草案）；<a href={`${baseUrl}本届理事会工作报告（草案）.docx`}
                                                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （11）本届理事会财务报告；<a href={`${baseUrl}本届理事会财务报告.docx`}
                                                  style={{color: 'blue'}}>点此下载</a></p>
                    <p> （12）法人离任财务审计报告；<a href={`${baseUrl}法人离任财务审计报告.docx`}
                                                    style={{color: 'blue'}}>点此下载</a></p>
                    <p> （13）天津市××××第×次会员（代表）大会议程；<a
                        href={`${baseUrl}天津市××××第×次会员（代表）大会议程.docx`}
                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （14）新一届理事会工作计划报告；<a href={`${baseUrl}新一届理事会工作计划报告.docx`}
                                                        style={{color: 'blue'}}>点此下载</a></p>
                    <p> （15）天津市××××理事监事候选人推荐表；<a href={`${baseUrl}天津市××××理事监事候选人推荐表.docx`}
                                                              style={{color: 'blue'}}>点此下载</a></p>
                    <p> （16）天津市××××第×届理事会理事候选人情况说明。<a
                        href={`${baseUrl}天津市××××第×届理事会理事候选人情况说明.docx`}
                        style={{color: 'blue'}}>点此下载</a>
                    </p>

                </div>
                <div className="panel-header">（二）社会团体换届过程中工作</div>
                <div className="panel-body">
                    <p>1．换届选举大会召开前需社科联报告，并填写《重大活动事先报告备案表》（一式三份，社科联留存一份，模板由市民政局提供）；</p>
                    <p>2．按照经批准的换届会员（代表）大会的议程召开会议；</p>
                    <p>3．保存好会议音像资料和文字档案；</p>
                </div>
                <div className="panel-header">（三）社会团体换届选举会议后续工作</div>
                <div className="panel-body">
                    <p> 社会团体换届选举后，15日内将会上通过的理事会名单等材料报市社科联备案，同时更新填报天津市社会组织管理系统相关数据，需报送材料包括（社科联留存一份）：</p>
                    <p> （1）会员（代表）大会纪要。</p>
                    <p> （2）会员（代表）大会通过的章程（骑缝盖社会团体章）。</p>
                    <p> （3）《天津市××××第×届理事会基本情况表》（骑缝盖社会团体章）。<a
                        href={`${baseUrl}天津市××××第×届理事会基本情况表.docx`} style={{color: 'blue'}}>点此下载</a>
                    </p>
                    <p> （4）《天津市××××第×届监事会（监事）基本情况表》（骑缝盖社会团体章）。<a
                        href={`${baseUrl}天津市××××第×届监事会（监事）基本情况表.docx`}
                        style={{color: 'blue'}}>点此下载</a>
                    </p>
                    <p> （5）《中共天津市××××第×届支部委员会委员情况表》（盖社会团体支部委员会章）。<a
                        href={`${baseUrl}中共天津市××××第×届支部委员会委员情况表.docx`}
                        style={{color: 'blue'}}>点此下载</a>
                    </p>
                </div>

                <div className="panel-header">（四）换届的有关规定</div>
                <div className="panel-body">
                    <p>1．社会团体理事会成员应有一定的学术造诣和威望，热心社会团体工作，年龄一般不超过70岁。理事会组成坚持老、中、青相结合的原则，会长或理事长、副会长或副理事长兼任同等职务一般不超过两个社会团体。会长或理事长由政治可靠、公道正派、德业双馨的业内专家或实务部门负责人担任，秘书长应具有较高的学术水平和组织协调能力，年富力强，热爱社会团体工作。</p>
                    <p>2．法定代表人一般由会长或理事长担任，不得兼任其他社会团体的法定代表人。</p>
                    <p>3．原则上，正副会长或理事长及秘书长任同一职务不得连续超过两届。</p>
                    <p>4．兼任社会团体理事以上（含监事）人员均需按照管理权限由组织人事部门审批。</p>
                    <p>5．理事会人数不得超过会员（代表）数的1/3，理事会中具有本领域正高级学术职称的专家学者不少于2/3，外地理事不能超过理事会成员总数的1/10。</p>
                    <p>6．常务理事会（理事人数50人以上）人数不得超过理事会人数的1/3。</p>
                    <p>7．理事会成员调整原则上不得少于1/3。</p>
                    <p>8．原则上，会员少于100（含）名的应召开会员大会。会员超过100名的，可召开会员代表大会。会员（代表）大会须有2/3以上的会员（代表）出席方能召开，其决议事项需经与会代表半数以上通过方能生效。</p>
                    <p>9．社会团体党组织与理事会成员交叉任职，与是中共党员的会长或理事长“一肩挑”。主动提名理事会中的党员作为党组织班子成员候选人，积极推荐党组织班子成员作为理事会成员候选人。</p>
                    <p>10．理事和财务管理人员不得兼任监事。</p>
                    <p>11．建立完善各项内部管理制度。</p>
                    <p>12．社会团体换届应与党组织换届同步进行。</p>
                </div>

                <div className="panel-header">（五）提前或延期换届</div>
                <div className="panel-body">
                    <p>1．社会团体因特殊情况需提前或延期换届的，应将经理事会表决通过的会议纪要和提前或延期换届申请报社科联批准后，报登记管理机关备案。</p>
                    <p>2．提前或延期换届，需向市社科联提交如下材料（延期换届在届满前3个月，向市社科联提交材料）：</p>
                    <p> （1）《关于天津市××××延期换届的请示》<a href={`${baseUrl}关于天津市××××延期换届的请示.docx`}
                                                            style={{color: 'blue'}}>点此下载</a></p>
                    <p> （2）填写《重大事项报告备案表》（模板由市民政局提供）。</p>
                    <p> （3）理事会会议纪要。</p>
                    <p>3．市社科联审查同意后，到市民政局办理提前或延期换届备案。</p>
                    <p>4．延期换届期限最长不超过1年。</p>
                </div>

                <div className="panel-header">（六）备案登记</div>
                <div className="panel-body">
                    <p> 社会团体换届大会后30日内，按市民政局有关要求，填写有关登记备案表格（相关备案登记表由市民政局提供），材料经市社科联审核后，报市民政局及社科联备案（社科联留存一份）。</p>
                </div>
            </div>
        </>
    );
};

export default ChangeOrganization;
